import { render } from "./DataTableOverview.vue?vue&type=template&id=4bd458f5&ts=true"
import script from "./DataTableOverview.vue?vue&type=script&lang=ts"
export * from "./DataTableOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__